angular.module('charts')
    .directive('dblStudentProficiencyGrowthArrow', [function() {
        var LINE_HEAD_OVERLAP_OFFSET = 2;  // reduce overlap of line and head
        var LINE_ACROSS_BORDER_OFFSET = 1;  // add to line to cross right border

        return {
            restrict: 'E',
            scope: {
                dblShowLine: '=',
                dblShowHead: '=',
                dblStartPercent: '=',
                dblEndPercent: '='
            },
            templateUrl: '/resources/charts/directives/student-proficiency-overview/dbl-student-proficiency-growth-arrow.directive.html',
            link: function(scope, element) {
                scope.getHeadStyle = function () {
                    var style = {};

                    if (scope.dblShowHead) {
                        style.display = 'block';
                        style.left = 'calc(' + scope.dblEndPercent + '% - 6px)';
                    }

                    return style;
                };

                scope.getLineStyle = function () {
                    var style = {};

                    if (scope.dblShowLine) {
                        style.display = 'block';
                        style.left = scope.dblStartPercent + '%';
                        var rightAdjustment = 0;

                        if (scope.dblShowHead) {
                            rightAdjustment += LINE_HEAD_OVERLAP_OFFSET;
                        } else {
                            // draw across border to continue
                            rightAdjustment -= LINE_ACROSS_BORDER_OFFSET;
                        }

                        rightAdjustment = rightAdjustment >= 0 ? '+ ' + rightAdjustment : '- ' + Math.abs(rightAdjustment);

                        style.right = 'calc(' + (100 - scope.dblEndPercent) + '% ' + rightAdjustment + 'px)';
                    }

                    return style;
                };


            }
        };
    }]);
